import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconArtifactTypeAlt = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6.5 7.5C6.5 7.08579 6.83579 6.75 7.25 6.75H13.25C13.6642 6.75 14 7.08579 14 7.5V9.50723C16.2308 9.63664 18 11.4867 18 13.75C18 16.0972 16.0972 18 13.75 18C11.5719 18 9.77657 16.3616 9.5291 14.25H7.25C6.83579 14.25 6.5 13.9142 6.5 13.5V7.5ZM11.0453 14.25C11.2805 15.5301 12.402 16.5 13.75 16.5C15.2688 16.5 16.5 15.2688 16.5 13.75C16.5 12.3155 15.4016 11.1375 14 11.0112V13.5C14 13.9142 13.6642 14.25 13.25 14.25H11.0453ZM12.5 11.2999V12.75H11.1875C11.4331 12.1211 11.9035 11.6048 12.5 11.2999ZM12.5 9.6868C11.0757 10.1244 9.97034 11.2904 9.61831 12.75H8V8.25H12.5V9.6868Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M3.25 5.00324C3.25 3.38965 4.70504 2.25 6.28888 2.25H17.7111C19.295 2.25 20.75 3.38965 20.75 5.00324V19.0043C20.7339 20.6078 19.2889 21.75 17.7111 21.75H6.28888C4.70504 21.75 3.25 20.6104 3.25 18.9968V5.00324ZM6.28888 3.75C5.3394 3.75 4.75 4.39965 4.75 5.00324V18.9968C4.75 19.6003 5.3394 20.25 6.28888 20.25H17.7111C18.6428 20.25 19.2418 19.6051 19.25 18.9925V5.00324C19.25 4.39965 18.6606 3.75 17.7111 3.75H6.28888Z",
		fill: "currentColor"
	})]
});
export { SvgIconArtifactTypeAlt as ReactComponent };
